/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelParagraph64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelParagraph64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path d="M52 27H12V26H52V27Z" fill="currentColor" />
            <path d="M52 33H12V32H52V33Z" fill="currentColor" />
            <path d="M12 39L32 39V38L12 38V39Z" fill="currentColor" />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelParagraph64Icon.tags = [
  'paragraph',
  'text',
  'align',
  'lines',
  'writing',
];

AddPanelParagraph64Icon.category = '64x64 (Add panel)';

AddPanelParagraph64Icon.iconSize = 64;
